<template>
  <div class="onboarding-step-indicator">
    <span class="step-eyebrow">Step {{ step }} of {{ totalSteps }}</span>
    <div class="step-dots" aria-hidden="true">
      <span
        v-for="n in totalSteps"
        :key="n"
        class="step-dot"
        :class="{ 'is-active': n === step, 'is-done': n < step }"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "OnboardingStepIndicator",
  props: {
    step: {
      type: Number,
      required: true,
    },
    totalSteps: {
      type: Number,
      default: 3,
    },
  },
};
</script>

<style scoped>
.onboarding-step-indicator {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.step-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
}

.step-dots {
  display: flex;
  gap: 6px;
}

.step-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #e5e7eb;
  transition: background-color 120ms ease, width 120ms ease;
}

.step-dot.is-done {
  background: rgba(1, 146, 86, 0.35);
}

.step-dot.is-active {
  background: #019256;
  width: 22px;
}
</style>
